const STRIPE_PAYMENT_URL =
  "https://buy.stripe.com/6oUbJ08du9NbeZp3Np88w1Sb";

const finalTrial = {
  typeInfo: "noQuestions",
  title: "Combinação perfeita para aulas online! 🎉",
  subtitle:
    "Parece que o formato de aulas com professor pode ser adequado para seu filho/sua filha: vocês têm a possibilidade técnica, um interesse claro em aulas regulares e condições adequadas para começar. Experimentem começar com a primeira aula gratuita!",
  button: "Experimentar grátis 🚀",
  nextStep: 20,
};

const coldTitle = "Vamos começar com uma recomendação clara 🎯";
const coldSubtitle =
  "Agora é melhor começar com uma recomendação clara: quais habilidades podem ser adequadas para a criança, quais projetos ela poderá criar e qual formato de aprendizagem será confortável.";

const finalPaid = {
  typeInfo: "noQuestions",
  title: coldTitle,
  subtitle: coldSubtitle,
  button: "Primeira aula paga",
  buttonEvent: "scoringpaidTC_button",
  redirectUrl: STRIPE_PAYMENT_URL,
  secondaryButton: {
    text: "Curso gratuito de 3 dias",
    url: "https://landing.kodland.org/br/onepager/free-mini-course",
    event: "scoringfreecourse_button",
  },
};

export default {
  newDesign: true,
  parameters: {
    landing_id: "GRBrQv39",
    segment: 42,
  },
  title: "Encontre o formato de aprendizagem ideal para seu filho/a | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  startPage: {
    footer: true,
    title:
      "Responda a estas 5 perguntas e receba uma aula gratuita para seu filho ou sua filha",
    subtitle:
      "Seu filho ou sua filha vai aprender programação e criar videogames e animações.",
    image: {
      url: "/welcome/fwd_latam_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/fwd_latam_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Pressione para continuar 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Se as aulas forem úteis para a criança, vocês estariam dispostos a considerar aulas regulares?",
      answers: [
        {
          answer: "Sim, já estamos considerando essa possibilidade.",
          nextStep: 2,
        },
        {
          answer: "Sim, se o preço for razoável.",
          nextStep: 6,
        },
        {
          answer: "Ainda não temos certeza, precisamos de mais informações.",
          nextStep: 10,
        },
        {
          answer: "Não, não planejamos pagar, mesmo que a criança goste.",
          nextStep: 17,
        },
      ],
    },

    2: {
      question: "Vocês têm um computador ou notebook em casa para as aulas?",
      answers: [
        { answer: "Sim, temos um computador ou notebook.", nextStep: 3 },
        { answer: "No momento, temos apenas celular ou tablet.", nextStep: 17 },
      ],
    },
    3: {
      question: "Quão estável é a conexão de internet em casa?",
      answers: [
        { answer: "Estável, normalmente sem problemas.", nextStep: 4 },
        { answer: "Às vezes cai.", nextStep: 8 },
        { answer: "Cai com frequência.", nextStep: 17 },
      ],
    },
    4: {
      question:
        "Qual orçamento mensal para o desenvolvimento da criança vocês consideram confortável?",
      financial: true,
      answers: [
        { answer: "Até 30 USD.", nextStep: 9 },
        { answer: "30–60 USD.", nextStep: 5 },
        { answer: "60–100 USD.", nextStep: 5 },
        { answer: "Mais de 100 USD.", nextStep: 13 },
      ],
    },
    5: {
      question: "A criança já teve experiência com aulas online?",
      answers: [
        { answer: "Não, ainda não teve.", nextStep: 14 },
        { answer: "Sim, uma vez ou por pouco tempo.", nextStep: 14 },
        { answer: "Sim, faz aulas online regularmente.", nextStep: 14 },
      ],
    },

    6: {
      question: "Vocês têm um computador ou notebook em casa para as aulas?",
      answers: [
        { answer: "Sim, temos um computador ou notebook.", nextStep: 7 },
        { answer: "No momento, temos apenas celular ou tablet.", nextStep: 17 },
      ],
    },
    7: {
      question: "Quão estável é a conexão de internet em casa?",
      answers: [
        { answer: "Estável, normalmente sem problemas.", nextStep: 8 },
        { answer: "Às vezes cai.", nextStep: 8 },
        { answer: "Cai com frequência.", nextStep: 17 },
      ],
    },
    8: {
      question:
        "Qual orçamento mensal para o desenvolvimento da criança vocês consideram confortável?",
      financial: true,
      answers: [
        { answer: "Até 30 USD.", nextStep: 13 },
        { answer: "30–60 USD.", nextStep: 9 },
        { answer: "60–100 USD.", nextStep: 9 },
        { answer: "Mais de 100 USD.", nextStep: 13 },
      ],
    },
    9: {
      question: "A criança já teve experiência com aulas online?",
      answers: [
        { answer: "Não, ainda não teve.", nextStep: 15 },
        { answer: "Sim, uma vez ou por pouco tempo.", nextStep: 15 },
        { answer: "Sim, faz aulas online regularmente.", nextStep: 15 },
      ],
    },

    10: {
      question: "Vocês têm um computador ou notebook em casa para as aulas?",
      answers: [
        { answer: "Sim, temos um computador ou notebook.", nextStep: 11 },
        { answer: "No momento, temos apenas celular ou tablet.", nextStep: 17 },
      ],
    },
    11: {
      question: "Quão estável é a conexão de internet em casa?",
      answers: [
        { answer: "Estável, normalmente sem problemas.", nextStep: 12 },
        { answer: "Às vezes cai.", nextStep: 12 },
        { answer: "Cai com frequência.", nextStep: 17 },
      ],
    },
    12: {
      question:
        "Qual orçamento mensal para o desenvolvimento da criança vocês consideram confortável?",
      financial: true,
      answers: [
        { answer: "Até 30 USD.", nextStep: 13 },
        { answer: "30–60 USD.", nextStep: 13 },
        { answer: "60–100 USD.", nextStep: 13 },
        { answer: "Mais de 100 USD.", nextStep: 13 },
      ],
    },
    13: {
      question: "A criança já teve experiência com aulas online?",
      answers: [
        { answer: "Não, ainda não teve.", nextStep: 16 },
        { answer: "Sim, uma vez ou por pouco tempo.", nextStep: 16 },
        { answer: "Sim, faz aulas online regularmente.", nextStep: 16 },
      ],
    },

    14: finalTrial,
    15: finalTrial,
    16: finalPaid,
    17: finalPaid,

    20: {
      title: "Quantos anos tem o seu filho/sua filha?",
      subtitle:
        "Escolheremos o curso que melhor se adapta à idade do seu filho/sua filha.",
      type: "age",
      button: "",
    },
    21: {
      title: "Agende uma aula gratuita",
      type: "one-page-contacts",
      subtitle:
        "Vamos nos conhecer, ver o que vamos aprender e como a aula funciona.",
      button: "Quase lá! 🔥",
    },
    22: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    23: {
      title: "Lembrete rápido antes da sua aula experimental ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, entre na aula a partir de um computador ou notebook e acompanhe seu filho/sua filha durante toda a aula. A aula experimental é individual e personalizada.",
      button: "O que mais?",
    },
    24: {
      title:
        "Manteremos contato por e-mail e WhatsApp antes da sua aula. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24 horas antes da aula e pediremos para você confirmar 2 horas antes. Manter contato nos ajuda a garantir que a aula aconteça conforme o planejado.",
      button: "O que mais?",
    },
    25: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    },
  },
};
